import Vue from 'vue'
import axios from "axios";


var AxiosProvider;
console.log('Axios Provider Loaded...');

export default {

  init(){

    var V_baseDomain = '/api/v1'
    if (Vue.prototype.$islocalhost) V_baseDomain = 'https://dev.maia.chat' + V_baseDomain

    var V_csrf = ''

    if(document.head.querySelector('meta[name="csrf-token"]')) V_csrf = document.head.querySelector('meta[name="csrf-token"]').content
    
    AxiosProvider = axios.create({
      baseURL: V_baseDomain,
      timeout: 1000,
      headers: {    
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': V_csrf
      }
    });

  },
    
  get(req_url,req_auth=true) {
    return new Promise((resolve, reject) =>{
    
      AxiosProvider.get(req_url).then(function (response) {        
        resolve({'status':response.status, 'response': response.data})
      }).catch(function (error) {

        if (typeof(error.response) != "undefined" && error.response.status==401){
            resolve({'status':error.response.status, 'error': error.message});   
            this._gotoLogin()
        }
       
        resolve({'status':500, 'error': error.message});        	
                 
      }.bind(this));  
    })    
  },
  
  post(req_url,params=null,req_auth=true) {
    return new Promise((resolve, reject) =>{

      AxiosProvider.post(req_url, params).then(function (response) {        
        resolve({'status':response.status, 'response': response.data})
      }).catch(function (error) {

        if (error.response.status==401){
          resolve({'status':error.response.status, 'error': error.message});   
          this._gotoLogin()
        }
       
        resolve({'status':500, 'error': error.message});        	
                 
      }.bind(this));  
    })    
  },

  patch(req_url,params=null,req_auth=true) {
    return new Promise((resolve, reject) =>{

      AxiosProvider.patch(req_url, params).then(function (response) {        
        resolve({'status':response.status, 'response': response.data})
      }).catch(function (error) {

        if (error.response.status==401){
          resolve({'status':error.response.status, 'error': error.message});   
          this._gotoLogin()
        }
       
        resolve({'status':500, 'error': error.message});        	
                 
      }.bind(this));  
    })    
  },  

  delete(req_url,req_auth=true) {
    return new Promise((resolve, reject) =>{

      AxiosProvider.delete(req_url).then(function (response) {        
        resolve({'status':response.status, 'response': response.data})
      }).catch(function (error) {

        if (error.response.status==401){
          resolve({'status':error.response.status, 'error': error.message});   
          this._gotoLogin()
        }
       
        resolve({'status':500, 'error': error.message});        	
                 
      }.bind(this));  
    })    
  },  

  _gotoLogin(){    
      
      if (! Vue.prototype.$islocalhost){
        document.location.href='/login';    
      } else{
        alert('You are not logged!!');
      }
  },
  
  serializeQuery(params, prefix=null) {
    const query = Object.keys(params).map((key) => {
      const value  = params[key];
            
      key = (prefix ? `${prefix}[${key}]` : key);
  
      if (typeof value === 'object')
        return this.serializeQuery(value, key);
      else
        return `${key}=${value}`;
    });
  
    return [].concat.apply([], query).join('&');        
  },
  
  getSerializedQuery(params){
    let paramstring = this.serializeQuery(params)
    if (paramstring!='') paramstring = "?" + paramstring
    return paramstring
  }   

};



 

